"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCompanyLabel = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var Box_1 = __importDefault(require("@mui/material/Box"));
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var TextButton_1 = __importDefault(require("atomicComponents/atoms/Buttons/TextButton"));
var LoadingSpinner_1 = __importDefault(require("atomicComponents/atoms/Icons/LoadingSpinner"));
var Autocomplete_1 = __importDefault(require("atomicComponents/organisms/Autocomplete"));
var SimplifyFormInput_1 = __importDefault(require("shared/components/Form/HoC/SimplifyFormInput"));
var Text_1 = __importDefault(require("shared/components/Text"));
var hooks_1 = require("utils/hooks");
var ordered_1 = require("utils/selectors/ordered");
var single_1 = require("utils/selectors/single");
var getCompanyLabel = function (company) { var _a; return (_a = company.name) !== null && _a !== void 0 ? _a : "ID: ".concat(company.id); };
exports.getCompanyLabel = getCompanyLabel;
var makeCompanyOption = function (company, k, companies) { return ({
    value: company.id,
    label: "".concat((0, exports.getCompanyLabel)(company)).concat(companies && companies.filter(function (c) { return (0, exports.getCompanyLabel)(c) === (0, exports.getCompanyLabel)(company); }).length > 1
        ? " (".concat(company.id, ")") : ''),
    renderLabel: {
        main: (0, exports.getCompanyLabel)(company),
        byline: "".concat(company.isTest ? ' (Test)' : '', "\n    ").concat(companies && companies.filter(function (c) { return (0, exports.getCompanyLabel)(c) === (0, exports.getCompanyLabel)(company); }).length > 1 ? " (".concat(company.id, ")") : ''),
    },
}); };
var SimplifiedAutocomplete = (0, SimplifyFormInput_1.default)(Autocomplete_1.default);
var CompanySelect = function (_a) {
    var _b, _c;
    var anchorEl = _a.anchorEl, setAnchorEl = _a.setAnchorEl;
    var _d = __read(react_1.default.useState(false), 2), skipTest = _d[0], setSkipTest = _d[1];
    var profileWithId = (0, react_redux_1.useSelector)(single_1.selectProfileWithId);
    var _e = __read((0, hooks_1.useSubmitter)('users', profileWithId.id), 2), submitter = _e[0], isSending = _e[1];
    var allCompaniesFromBatches = (_b = (0, react_redux_1.useSelector)(ordered_1.selectMiniCompaniesFromBatches)) === null || _b === void 0 ? void 0 : _b.filter(function (c) { return !skipTest || !c.isTest; });
    var miniCompanies = end2end_1.IS_RECHARGLY ? allCompaniesFromBatches === null || allCompaniesFromBatches === void 0 ? void 0 : allCompaniesFromBatches.filter(function (c) { return c.hasRecharglyAccess; }) : allCompaniesFromBatches;
    var selectedCompany = miniCompanies === null || miniCompanies === void 0 ? void 0 : miniCompanies.find(function (company) { return company.id === profileWithId.companyId; });
    var handleChange = function (newValue) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(newValue === null || newValue === void 0 ? void 0 : newValue.value)) return [3 /*break*/, 2];
                    return [4 /*yield*/, submitter({ companyId: newValue.value })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    if (!miniCompanies) {
        return (0, jsx_runtime_1.jsx)(LoadingSpinner_1.default, { style: { marginLeft: 16 } });
    }
    return ((0, jsx_runtime_1.jsx)(SimplifiedAutocomplete, { options: (_c = miniCompanies === null || miniCompanies === void 0 ? void 0 : miniCompanies.map(makeCompanyOption)) !== null && _c !== void 0 ? _c : [], label: "Select a company", placeholder: "Select a company", onChange: handleChange, noOptionsText: "Company not found", value: selectedCompany ? makeCompanyOption(selectedCompany) : null, elementRef: { elmRef: anchorEl, setElmRef: setAnchorEl }, loading: isSending, isDisabled: isSending, anchorOrigin: { vertical: 'top', horizontal: 'left' }, loadOnChange: true, renderTags: function () { return null; }, renderOption: function (props, option) {
            var _a, _b;
            return ((0, jsx_runtime_1.jsx)("li", __assign({}, props, { children: (0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ display: "flex", flexDirection: "column" }, { children: [(0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: (_a = option.renderLabel) === null || _a === void 0 ? void 0 : _a.main })), ((_b = option.renderLabel) === null || _b === void 0 ? void 0 : _b.byline) && ((0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: "caption", fontSize: 12, color: "riverstone", width: 1 }, { children: option.renderLabel.byline })))] })) })));
        }, endAdornment: ((0, jsx_runtime_1.jsx)(TextButton_1.default, __assign({ color: "neutral", size: "small", onClick: function () { return setSkipTest(!skipTest); } }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ style: { textDecoration: skipTest ? 'line-through' : undefined } }, { children: "test" })) }))) }));
};
exports.default = CompanySelect;
